import moment from 'moment';
import WorkoutResultBase from './WorkoutResultBase';

class WorkoutResult extends WorkoutResultBase {
  constructor({
    _id = null,
    user = null,
    wod = null,
    workout = null,
    workoutType = null,
    workoutTypeModel = null,
    date = null,
    result = null,
    resultType = '',
    isPublic = null,
    createdAt = null,
    updatedAt = null,
  }) {
    super();

    this.id = _id;
    this.user = user;
    this.wod = wod;
    this.workout = workout;
    this.workoutType = workoutType;
    this.workoutTypeModel = workoutTypeModel;
    this.date = date ? moment(date) : null;
    this.result = result;
    this.resultType = resultType;
    this.isPublic = isPublic;
    this.createdAt = createdAt ? moment(createdAt) : null;
    this.updatedAt = updatedAt ? moment(updatedAt) : null;
  }
}

export default WorkoutResult;
